import React, { createContext, useState, useCallback, useMemo } from 'react';
var MenuContext = /*#__PURE__*/createContext();
export function MenuProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      opened = _useState[0],
      setOpened = _useState[1];

  var toggle = useCallback(function () {
    return setOpened(function (opened) {
      return !opened;
    });
  }, []);
  var value = useMemo(function () {
    return {
      opened: opened,
      toggle: toggle
    };
  }, [opened, toggle]);
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: value
  }, children);
}
var MenuConsumer = MenuContext.Consumer;
export { MenuConsumer };